import { Box, Input, FormLabel, FormControl, SimpleGrid, Heading, Container, Button, Checkbox, Thead, Divider, Table, Tbody, Th, Tr, Td, Text, Flex } from '@chakra-ui/react';
import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

export const ThreeDS = () => {
const baseUrl = 'https://bff.pcip.barte.com/service/payment';
const baseUrlMonolito = 'https://bff.barte.com/service/core';
const baseUrlMonolitoV2 = 'https://hml-api.barte.com';
const [isTokenButtonDisabled, setIsTokenButtonDisabled] = useState(false);
const [isSessionButtonDisabled, setIsSessionButtonDisabled] = useState(false);
const [isPayButtonDisabled, setIsPayButtonDisabled] = useState(false);
const [tokenButtonText, setTokenButtonText] = useState('Criar Token');
const [sessionButtonText, setSessionButtonText] = useState('Criar Sessão');
const [payButtonText, setPayButtonText] = useState('Pagar');
const [tokenData, setTokenData] = useState(null);
const [sessionData, setSessionData] = useState(null);

const amountInput = useRef<HTMLInputElement>(null);
const holdernameInput = useRef<HTMLInputElement>(null);
const cardNumberInput = useRef<HTMLInputElement>(null);
const cvvInput = useRef<HTMLInputElement>(null);
const expirationInput = useRef<HTMLInputElement>(null);
const buyerUuidInput = useRef<HTMLInputElement>(null);
const tokenApi = useRef<HTMLInputElement>(null);
const cardToken = useRef<HTMLInputElement>(null);
const tokenApiValue = 'd47ee860-81e7-4c67-90ef-37feb787c528'
const navigate = useNavigate();
const createToken = async (card) => {
  const response = await fetch(`${baseUrl}/v1/cards`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Token-Api': tokenApi.current?.value || tokenApiValue
    },
    body: JSON.stringify(card)
  });

  return await response.json();
};


const getCharge = async (id) => {
  const response = await fetch(`${baseUrl}/v1/charges?transaction=${id}`);
  return await response.json();
};

const createCharge = async (setupId, amount, cardId, cardIdUUID) => {
    const payload = {
      startDate: new Date().toISOString().split('T')[0],
      value: amount,
      installments: 1,
      urlCallBack: "https://brave-advertisement-84.webhook.cool",
      title: "Titulo - Lili oPihAk",
      description: "Robson - Lili xn6avt",
      payment: {
        method: "CREDIT_CARD_EARLY_BUYER",
        cardToken: cardId,
        card: {
          cvv: cvvInput.current?.value
        },
        fraudData: {
          document: "04909778128",
          internationalDocument: {
            documentNumber: "04909778128",
            documentType: "cpf",
            documentNation: "BR"
          },
          name: "Lili - OgCCRq",
          email: "strigus@mock.com",
          phone: "5511999994444",
          billingAddress: {
            country: "BR",
            state: "MG",
            city: "Uberlandia",
            district: "Patrimonio",
            street: "Rua de test",
            zipCode: "38411999",
            number: "S/N",
            complement: "apart 999"
          }
        }
      },
      uuidBuyer: buyerUuidInput.current?.value,
      threeDSecure: {
        dataOnly: false,
        requiresLiabilityShift: false,
        setupId: setupId,
        redirectURL: "https://app.barte.com/login",
        requestorURL: "https://app.barte.com/",
        browser: {
          ip: "127.0.0.1",
          userAgent: navigator.userAgent,
          acceptHeader: "text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8",
          language: navigator.language,
          colorDepth: screen.colorDepth,
          screenHeight: screen.height,
          screenWidth: screen.width,
          timeZoneOffset: new Date().getTimezoneOffset().toString(),
          javaEnabled: navigator.javaEnabled(),
          javaScriptEnabled: true
        },
        billingAddress: {
            "country": "BR",
            "state": "MG",
            "city": "Uberlandia",
            "district": "Patrimonio",
            "street": "Rua de test",
            "zipCode": "38411999",
            "streetNumber": "0",
            "complement": "apart 999"
        },
        cardHolder: {
            email: "teste@teste.com",
            mobilePhone: "24999329393"
        }
      }
    };
    const payload2 = {
        "startDate": new Date().toISOString().split('T')[0],
        "value": 100,
        "installments": 1,
        "title": `Compra 3ds ${new Date().toLocaleDateString()}`,
        "payment": {
            "method": "CREDIT_CARD",
            "card": {
                "cvv": "220"
            },
            "cardToken": cardId,
            "fraudData": {
                "document": "91094326046",
                "name": "Teste 3ds ",
                "email": "teste@teste.com",
                "phone": "21999999999",
                "billingAddress": {
                    "country": "BR",
                    "state": "RJ",
                    "city": "Rio de Janeiro",
                    "district": "Botafogo",
                    "street": "Rua Bambina",
                    "zipCode": "22251050",
                    "number": "201",
                    "complement": ""
                }
            }
        },
        "threeDSecure": {
            "dataOnly": false,
            "requiresLiabilityShift": false,
            "setupId": setupId,
            "redirectURL": "https://www.google.com", // tela finalização do pagamento
            "requestorURL": "https://www.google.com",
            "browser": {
                "ip": "127.0.0.1",
                "userAgent": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/137.0.0.0 Safari/537.36",
                "acceptHeader": "text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8",
                "language": "en-US",
                "colorDepth": 24,
                "screenHeight": 1440,
                "screenWidth": 2560,
                "timeZoneOffset": "180",
                "javaEnabled": false,
                "javaScriptEnabled": true
            },
            "billingAddress": {
                "country": "BR",
                "state": "MG",
                "city": "Uberlandia",
                "district": "Patrimonio",
                "street": "Rua de test",
                "zipCode": "38411999",
                "streetNumber": "0",
                "complement": "apart 999"
            },
            "shippingAddress": {
                "country": "BR",
                "state": "MG",
                "city": "Uberlandia",
                "district": "Patrimonio",
                "street": "Rua de test",
                "zipCode": "38411999",
                "streetNumber": "0",
                "complement": "apart 999"
            },
            "cardHolder": {
                "email": "teste@teste.com",
                "mobilePhone": "24999329393"
            }
        },
        "uuidBuyer": "d4aa17eb-901a-458b-97e1-0af3c81ace3a"
    }

    const response = await fetch(`${baseUrlMonolito}/v1/orders`, {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        'X-Token-Api': tokenApi.current?.value || tokenApiValue
        },
        body: JSON.stringify(payload)
    });

    return await response.json();
}

const handleCreateToken = async () => {
  setIsTokenButtonDisabled(true);
  setTokenButtonText('Criando token...');
  
  const cardData = {
    holderName: holdernameInput.current?.value,
    number: cardNumberInput.current?.value, 
    cvv: cvvInput.current?.value,
    expiration: expirationInput.current?.value,
    buyerUuid: buyerUuidInput.current?.value
  };

  try {
    const token = await createToken(cardData);
    setTokenData(token);
    cardToken.current.value = token.cardId;
    setTokenButtonText('Token criado!');
    setIsTokenButtonDisabled(false);
  } catch (error) {
    console.error('Erro ao criar token:', error);
    setTokenButtonText('Erro ao criar token');
    setTokenData(null);
    setIsTokenButtonDisabled(false);
  }
};

const handleCreateSession = async () => {
  if (!tokenData) {
    alert('Crie um token primeiro!');
    return;
  }

  setIsSessionButtonDisabled(true);
  setSessionButtonText('Criando sessão...');

  try {
    const payload = {
      sourceType: 'card',
      cardId: tokenData.cardId
    };

    const response = await fetch(`${baseUrlMonolito}/v1/3ds/session`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Token-Api': tokenApi.current?.value || tokenApiValue
      },
      body: JSON.stringify(payload)
    });

    const setup = await response.json();
    setSessionData({
      setup,
      cardId: cardToken.current?.value || tokenData.cardId,
      cardUUID: tokenData.uuid
    });
    setSessionButtonText('Sessão criada!');
    setIsSessionButtonDisabled(false);
  } catch (error) {
    console.error('Erro ao criar sessão:', error);
    setSessionButtonText('Erro ao criar sessão');
    setSessionData(null);
    setIsSessionButtonDisabled(false);
  }
};

const handlePayClick = async () => {
  if (!sessionData) {
    alert('Crie uma sessão primeiro!');
    return;
  }

  setIsPayButtonDisabled(true);
  setPayButtonText('Pagamento em andamento...');
  const amount = parseInt(amountInput.current?.value || '0', 10);

  try {
    const { cardId, cardUUID, setup } = sessionData;
    const { id: setupId, collectUrl, token } = setup;
    
    const cardinalForm = document.getElementById('cardinal_collection_form') as HTMLFormElement;
    const cardinalInput = document.getElementById('cardinal_collection_form_input') as HTMLInputElement;
    cardinalForm.action = collectUrl;
    cardinalInput.value = token;
    cardinalForm.submit();

    window.addEventListener('message', async (event) => {
      if (collectUrl && event.origin === new URL(collectUrl).origin) {
        const data = JSON.parse(event.data);

        const chargeResponse = await createCharge(setupId, amount, cardId, cardUUID);
        localStorage.setItem('transactionId', chargeResponse.uuid);

        if (chargeResponse.status === 'PAID') {
          alert('Pagamento realizado com sucesso');
          return;
        }

        const stepForm = document.getElementById('step_up_form') as HTMLFormElement;
        const stepInput = document.getElementById('step_up_form_jwt_input') as HTMLInputElement;

        stepForm.action = chargeResponse.threeDSSecure.auth.stepUrl;
        stepInput.value = chargeResponse.threeDSSecure.auth.token;
        stepForm.submit();
      }
    });

  } catch (error) {
    console.error('Erro no pagamento:', error);
    setPayButtonText('Erro no pagamento');
  } finally {
    setIsPayButtonDisabled(false);
    setPayButtonText('Pagar');
  }
};

  return (
    <Box bg="gray.50">
      <Container maxW="container.xl">
        <Box as="main">
          <Box py={5} textAlign="center">
            <Heading size="lg">Malga - Demo 3DS</Heading>
            <Box h={4} />
          </Box>

          <SimpleGrid columns={1} spacing={5}>
            <FormControl>
              <FormLabel htmlFor="input_holdername">Holdername</FormLabel>
              <Input 
                id="input_holdername"
                ref={holdernameInput}
                defaultValue="Jose das neves test"
                placeholder="Jose da silva"
              />
            </FormControl>

            <FormControl>
              <FormLabel htmlFor="input_cardnumber">CardNumber</FormLabel>
              <Input 
                type="number"
                id="input_cardnumber"
                ref={cardNumberInput}
                defaultValue="5383638854440891"
                placeholder="4000000000002503"
              />
            </FormControl>

            <FormControl>
              <FormLabel htmlFor="input_expiration">Expiration</FormLabel>
              <Input 
                id="input_expiration"
                ref={expirationInput}
                defaultValue="12/2025"
                placeholder="MM/yyyy"
              />
            </FormControl>

            <FormControl>
              <FormLabel htmlFor="input_cvv">CVV</FormLabel>
              <Input 
                type="number"
                id="input_cvv"
                ref={cvvInput}
                defaultValue="220"
                placeholder="123"
              />
            </FormControl>

            <FormControl>
              <FormLabel htmlFor="input_buyeruuid">Buyer UUID</FormLabel>
              <Input 
                id="input_buyeruuid"
                ref={buyerUuidInput}
                defaultValue="9142aa91-e455-45b2-9c16-9716cfc23e70"
                placeholder="UUID do comprador"
              />
            </FormControl>

            <FormControl display="flex" alignItems="center">
              <FormLabel mb="0">3DS: DataOnly</FormLabel>
              <Checkbox id="input_dataonly" />
            </FormControl>

            <FormControl display="flex" alignItems="center">
              <FormLabel mb="0">Requires Liability Shift</FormLabel>
              <Checkbox id="input_liability" />
            </FormControl>

            <FormControl>
              <FormLabel htmlFor="input_installments">Installments</FormLabel>
              <Input 
                type="number"
                id="input_installments"
                defaultValue="1"
                min={1}
                placeholder="Número de parcelas"
              />
            </FormControl>

            <Divider />

            <FormControl>
              <FormLabel htmlFor="input_amount">Amount (Cents)</FormLabel>
              <Input 
                type="number"
                id="input_amount"
                ref={amountInput}
                defaultValue="5790"
                placeholder="100"
              />
            </FormControl>

            <FormControl>
              <FormLabel htmlFor="input_tokenapi">Token API</FormLabel>
              <Input 
                id="input_tokenapi"
                ref={tokenApi}
                defaultValue='d47ee860-81e7-4c67-90ef-37feb787c528'
              />
            </FormControl>
            <FormControl>
              <FormLabel htmlFor="input_cardtoken">CardToken</FormLabel>
              <Input 
                id="input_cardtoken"
                ref={cardToken}
                placeholder='Card token'
                onChange={(e) => cardToken.current.value = e.target.value}
                value={cardToken.current?.value}
              />
            </FormControl>

            <Flex gap={4}>
              <Button 
                colorScheme="blue" 
                onClick={handleCreateToken} 
                isDisabled={isTokenButtonDisabled}
                flex={1}
              >
                {tokenButtonText}
              </Button>

              <Button 
                colorScheme="green" 
                onClick={handleCreateSession} 
                isDisabled={isSessionButtonDisabled}
                flex={1}
              >
                {sessionButtonText}
              </Button>

              <Button 
                colorScheme="purple" 
                onClick={handlePayClick} 
                isDisabled={isPayButtonDisabled}
                flex={1}
              >
                {payButtonText}
              </Button>
            </Flex>
          </SimpleGrid>

          <Divider my={4} />
          
          <Table>
            <Thead>
              <Tr>            
                <Th>Card Token</Th>
              </Tr>
            </Thead>
            <Tbody>
              <Tr>
                <Td>{tokenData?.brand}</Td>
                <Td>{tokenData?.buyerId}</Td>
                <Td>{tokenData?.cardHolderName}</Td>
                <Td>{tokenData?.cardId}</Td>
                <Td>{tokenData?.createdAt}</Td>
                <Td>{tokenData?.cvvChecked}</Td>
                <Td>{tokenData?.expirationMonth}</Td>
                <Td>{tokenData?.expirationYear}</Td>
                <Td>{tokenData?.fingerprint}</Td>
                <Td>{tokenData?.first6digits}</Td>
                <Td>{tokenData?.last4digits}</Td>
                <Td>{tokenData?.status}</Td>
                <Td>{tokenData?.uuid}</Td>
              </Tr>
            </Tbody>
          </Table>
        </Box>

        <Box as="footer" my={5} pt={5} textAlign="center" color="gray.500">
          <Text>&copy; Malga - Demo 3DS</Text>
        </Box>
      </Container>
    <div style={{ display: "none" }}>
      <iframe id="cardinal_collection_iframe" name="collectionIframe" height="1" width="1"></iframe>
      <form id="cardinal_collection_form" method="POST" target="collectionIframe">
        <input id="cardinal_collection_form_input" type="text" name="JWT" value="" />
      </form>
    </div>
    <div style={{ display: "none" }}>
      <form id="step_up_form" name="stepup" method="POST" action="">
        <input id="step_up_form_jwt_input" type="text" name="JWT" value="" />
      </form>

      <iframe id="step_up_iframe" style={{
        border: "none",
        marginLeft: "auto",
        marginRight: "auto",
        display: "block"
      }}
        height="800px" width="400px" name="stepUpIframe"></iframe>
    </div>
    </Box>
  );
};